import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FontLoaderService {
  constructor() {
    this.loadFont();
  }

  private loadFont() {
    document.fonts.load('1rem Material Symbols Outlined').then(() => {
      console.log('Font loaded!');
      document.body.classList.add('font-loaded');
    });
  }
}
